// local
//const baseUrl = "http://localhost:3000/";

// production
 const baseUrl = "http://bitsat.com/";
export default baseUrl